var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('YorkbbsLoginDialog',{attrs:{"type":_vm.loginType,"visible":_vm.loginVisible},on:{"update:type":function($event){_vm.loginType=$event},"update:visible":function($event){_vm.loginVisible=$event}}}),_c('YorkbbsMobileAlert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }